module.exports = __webpack_public_path__ + "img/1.715e7ae7.png";